import { swSettings } from "app/common/services/swSettings";

import type { IComponentMonitorAndProtectConfig } from "../shared/data/component-config/component-config.types";

export class MonitorAndProtectAccessManager {
    private static instance: MonitorAndProtectAccessManager | null = null;

    private readonly component: IComponentMonitorAndProtectConfig;

    private constructor() {
        this.component = swSettings.components.MonitorAndProtectMaster as IComponentMonitorAndProtectConfig;
    }

    static getInstance(): MonitorAndProtectAccessManager {
        if (!MonitorAndProtectAccessManager.instance) {
            MonitorAndProtectAccessManager.instance = new MonitorAndProtectAccessManager();
        }
        return MonitorAndProtectAccessManager.instance;
    }

    get isAllowed(): boolean {
        return this.component.isAllowed;
    }

    get isBeta(): boolean {
        return this.component.isBeta;
    }
}
